<div
  echarts
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
  (chartClick)="onChartClick($event)"
  class="strip-plot-chart"
></div>
